export const PROPS_CLASSES = {
  imageFit: {
    none: "object-none",
    cover: "object-cover",
    contain: "object-contain",
    fill: "object-fill",
    "scale-down": "object-scale-down"
  }
};
export const CDN_URL = "https://cdn0.it4profit.com/s3size/el:t/f:webp/rt:fill/plain/s3:/";
